import * as Yup from 'yup'

const cancelValidationSchema = Yup.object().shape({
  reason: Yup.string().required('Reason is required'),
})
const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/
const rescheduleValidationSchema = Yup.object().shape({
  date: Yup.date().required(),
  time: Yup.string()
    .matches(timeRegex, 'Invalid time format for startTime')
    .nullable()
    .notRequired(),
  shift: Yup.string().required(),
  shareAnything: Yup.string().notRequired(),
})

const institutionCreateAppointmentValidationSchema = Yup.object().shape({
  createdBy: Yup.number().required('Patient is required'),
  userId: Yup.number().required('Doctor is required'),
  time: Yup.string().required('Time is required'),
  infos: Yup.object().shape({
    shift: Yup.string().required('Shift is required'),
    appointmentType: Yup.string().required('Appointment Type is required'),
  }),
})

export default {
  cancelValidationSchema,
  rescheduleValidationSchema,
  institutionCreateAppointmentValidationSchema,
}
